module.exports = __webpack_public_path__ + "img/oficina-ambato.1d98a6f1.png";